import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/App.css';
import '../css/Payment.css';
import ls from 'local-storage';
import Loading from "./Loading";
import Retry from "./Retry";
import axios from "axios";
import Address from "../Modules/Address";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import Cookies from 'js-cookie'
class Payment extends React.Component{
    list =[];

    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            retry: false,
            error: false,
            error_text: "",
            loading: false,
            payment_type:-1,
            discount_code:"",
            dialogHasConfirm:false,
            price:0,
            discount:0,
            total_price:0,
            delivery_price:0,
            final_price:0,
            cash_permission:0,
        };
    }

    componentDidMount(){
        if(
            ls.get("TotalPrice") != null &&
            ls.get("price") != null &&
            ls.get("TotalPriceWithDiscount") != null &&
            ls.get("order_id") != null &&
            ls.get("cash_permission") != null
        )
            this.setState({
                price:ls.get("TotalPrice"),
                total_price:parseInt(ls.get("TotalPrice")) - parseInt(ls.get("TotalPriceWithDiscount")),
                delivery_price:ls.get("price"),
                final_price:parseInt(ls.get("TotalPrice")) + parseInt(ls.get("price")) - parseInt(ls.get("TotalPriceWithDiscount")),
                cash_permission:ls.get('cash_permission'),
            });
        else
            this.props.history.push("/home");


        this.PaymentCheck();

    };

    render() {
        let nextButton = '';
        if(ls.get('cash_permission') == 1)
            nextButton = (
                <div className={(this.state.payment_type === 5)?"payBtn active":"payBtn"} onClick={()=>{this.payTypeHandler(5)}}>
                    <img src={`${process.env.PUBLIC_URL}/assets/images/pos.png`} className={"payImg"}/>
                    <span className={"payText"}><i>درب منزل</i></span>
                </div>
            );
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);

        let dialogConfirm = "";
        if(this.state.dialogHasConfirm)
            dialogConfirm = (
                <Button onClick={this.handleConfirm} color="success" autoFocus>
                    تایید
                </Button>
            );
        return (
            <div className="App ">
                <Loading loading={this.state.loading}/>
                <div className="App-body bg-white">
                    <div className={"content payment"}>
                        <div id={"topTitle"}>
                            <img src={`${process.env.PUBLIC_URL}/assets/images/back.png`} onClick={()=>{this.props.history.push({
                                pathname: '/address',
                                state: {
                                    type:"order",
                                    TotalPrice:ls.get("TotalPrice"),
                                    TotalPriceWithDiscount:ls.get("TotalPriceWithDiscount"),
                                    order_id:ls.get("order_id")}
                            });}}  id={"paymentBackBtn"}/>
                            <span id={"title"}><i>انتخاب نحوه پرداخت</i></span>
                        </div>


                        <div id={"discountDiv"}>
                            <div id={"discountItem"}>
                                <label id={"discountLabel"}><i>کد تخفیف</i></label>
                                <input type={"text"} id={"discount"} value={this.state.discount_code} onChange={this.handleDiscountChange}/>
                            </div>

                            <button id={"discountBtn"}>اعمال کد تخفیف</button>
                        </div>
                        <div id={"alertDiv"}>
                            <img src={`${process.env.PUBLIC_URL}/assets/images/alert.png`} id={"alertImg"}/>
                            <span id={"alertText"}>لطفا نحوه پرداخت سبد خرید را انتخاب کنید</span>
                        </div>

                        <div className={"payTypeDiv"}>
                            <div className={(this.state.payment_type === 7)?"payBtn active":"payBtn"}  onClick={()=>{this.payTypeHandler(7)}}>
                                <img src={`${process.env.PUBLIC_URL}/assets/images/creditico.png`} className={"payImg"}/>
                                <div className={"payText"}><i>اعتباری</i></div>
                            </div>
                            {nextButton}
                            <div className={(this.state.payment_type === 4)?"payBtn active":"payBtn"} onClick={()=>{this.payTypeHandler(4)}}>
                                <img src={`${process.env.PUBLIC_URL}/assets/images/onlineico.png`} className={"payImg"}/>
                                <span className={"payText"}><i>آنلاین</i></span>
                            </div>
                        </div>

                        <div className={"priceDiv"}>
                            <span className={"priceLabel"}>هزینه محصولات :</span>
                            <span className={(this.state.total_price < this.state.price)?"priceAmount dashed":"priceAmount"}>{new Intl.NumberFormat("fa").format(this.state.price)} تومان</span>
                        </div>
                        <div className={"priceDiv"}>
                            <span className={"priceLabel"}>هزینه محصولات با تخفیف :</span>
                            <span className={"priceAmount"}>{new Intl.NumberFormat("fa").format(this.state.total_price)} تومان</span>
                        </div>
                        <div className={"priceDiv"}>
                            <span className={"priceLabel"}>هزینه پیک :</span>
                            <span className={"priceAmount"}>{new Intl.NumberFormat("fa").format(this.state.delivery_price)} تومان</span>
                        </div>

                        <hr className={"payment_hr"}/>

                        <div className={"priceDiv"}>
                            <span className={"priceLabel"}>قابل پرداخت :</span>
                            <span className={"priceAmount"}>{new Intl.NumberFormat("fa").format(this.state.final_price)} تومان</span>
                        </div>
                    </div>

                    <button id={"payButton"} onClick={this.submitOrder}>پرداخت</button>

                    <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{this.state.dialogTitle}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {this.state.dialogText}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                بستن
                            </Button>
                            {dialogConfirm}
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
        );
    }

    handleClose  = () => {
        this.setState({open:false})
    };
    handleDiscountChange  = (event) => {
        this.setState({discount_code: event.target.value});
    };
    payTypeHandler(type){
        this.setState({payment_type:type});
    }

    submitOrder = ()=>{
        if(this.state.payment_type === 4 ||this.state.payment_type === 5 ||this.state.payment_type === 7)
            this.setState({
                open:true,
                dialogHasConfirm:true,
                dialogText:"هزینه سفارش شما "+new Intl.NumberFormat("fa").format(this.state.final_price)+" تومان است. سفارش ثبت شود ؟",
                dialogTitle:"آیا میخواهید ادامه دهید ؟",
                loading:false,
            });
        else
            this.setState({
                open:true,
                dialogHasConfirm:false,
                dialogText:"لطفا نحوه پرداخت را انتخاب کنید.",
                dialogTitle:"خطا",
                loading:false,
            });
    };

    handleConfirm = () =>{
        this.setState({
            loading:true,
        });
        let data = {
            pay_radio:this.state.payment_type,
            order_id:ls.get("order_id"),
            takhfif:this.state.discount_code,
            token:ls.get("token"),
        };
        axios.post(urls.baseUrl+urls.payment,data)
            .then(res => {
                if(res.data.code == 200){
                    if(this.state.payment_type === 5 || this.state.payment_type === 7){
                        ls.remove("list");
                        alert("سفارش با موفقیت ثبت شد.");
                        this.props.history.push("/home");
                    }
                    else{
                        window.location = res.data.link;
                    }

                }
                else{
                    this.setState({
                        open:true,
                        dialogHasConfirm:false,
                        dialogText:res.data.message,
                        dialogTitle:"خطا",
                        loading:false,
                    });
                }
            })
    };

    PaymentCheck = ()=>{
        let pay = Cookies.get('pay');
        if(pay == null)
            return;

        if(pay == 1){
            ls.remove("list");
            Cookies.remove('pay');
            alert("سفارش با موفقیت ثبت شد.");
            this.props.history.push("/home");
        }
        else{
            alert("پرداخت ناموفق بود. لطفا مجددا تلاش کنید.");
            Cookies.remove('pay');
        }
    }
}



export default Payment;
